import { CountryCode } from "./types";

// TODO: test case with non [0-9] char
// Type: needs string
export function cellphoneIsValid(code: CountryCode, value: string): boolean {
  const filtered = value.replace(/[^0-9]/g, ""); // Remove non-digits from phone number
  return (
    filtered.length == cellphoneRequiredLength(code) &&
    firstDigitIsValid(code, filtered[0])
  );
}

export function firstDigitIsValid(code: CountryCode, numStr: string) {
  const digits = VALID_CELLPHONE_LENGHTS[code] || "6";
  return digits == numStr || digits.includes(numStr);
}

export function cellphoneRequiredLength(code: CountryCode) {
  // Ecuador has 9 digits, rest has 8 (so far)
  return code === "593" ? 9 : 8;
}

export function cellphoneMask(code: CountryCode) {
  // Ecuador has 9 digits, rest has 8 (so far)
  return code === "593" ? "9-9999-9999" : "9999-9999";
}

// 12345678 -> 1234-5678
export function formatPhone(value: string) {
  const limiter = 4;
  const str = value.toString();
  if (str.length == 9) {
    return `${str[0]}-${str.substring(1, limiter + 1)}-${str.substring(
      limiter + 1,
      limiter * 2 + 1
    )}`;
  }
  if (str.length > limiter) {
    return `${str.substring(0, limiter)}-${str.substring(
      limiter,
      limiter * 2
    )}`;
  } else {
    return str;
  }
}

const VALID_CELLPHONE_LENGHTS: {
  [index in CountryCode]: string | string[];
} = {
  507: "6", // https://en.wikipedia.org/wiki/Telephone_numbers_in_Panama
  506: ["3", "5", "6", "7", "8"], // https://en.wikipedia.org/wiki/Telephone_numbers_in_Costa_Rica
  502: ["3", "4", "5"], // https://en.wikipedia.org/wiki/Telephone_numbers_in_Guatemala
  503: ["6", "7"], // https://en.wikipedia.org/wiki/Telephone_numbers_in_El_Salvador
  593: "9", // https://en.wikipedia.org/wiki/Telephone_numbers_in_Ecuador
};
